import { createContext } from 'react';
export const GlobalInfo = createContext();